import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MultiselectItem } from '../../../core/interfaces/admin.interface';
import { VipCardWithdrawal } from '../../../core/interfaces/product.interface';
import { PortalService } from '../../../core/services/portal.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-withdrawal-select',
  templateUrl: './withdrawal-select.component.html',
  styleUrls: ['./withdrawal-select.component.scss']
})
export class WithdrawalSelectComponent implements OnInit {

  @Input() withdrawalSelected: MultiselectItem[] = [];
  @Output() withdrawalSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  withdrawalList: MultiselectItem[] = [];

  constructor(
    private portalService: PortalService,
  ) { }

  ngOnInit() {
    this.loadMultiselectItems();
  }

  loadMultiselectItems(): void {
    const withdrawalType = VipCardWithdrawal;
    this.withdrawalList = this.portalService.getItemsFromEnum(withdrawalType);
  }

  onWithdrawalSelect(): void {
    this.withdrawalSelectedChange.emit(this.withdrawalSelected);
    this.onSelected.emit(this.withdrawalSelected);
  }

}
